// extracted by mini-css-extract-plugin
module.exports = {"centralBlock":"styles_centralBlock__3Aeyp"};